export default "__VITE_PUBLIC_ASSET__1893eafb__"